angular.module('tgaAdmin').controller('OverwriteTranslationController', [
  '$scope',
  '$uibModalInstance',
  function ($scope, $uibModalInstance) {
    $scope.initialize = function () {};
    $scope.actions = {
      overwriteTranslation() {
        $uibModalInstance.close(false);
      },
      keepExistingTranslation() {
        $uibModalInstance.close(true);
      },
      cancel() {
        $uibModalInstance.dismiss();
      },
    };

    $scope.initialize();
  },
]);
